import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import i18next from 'i18next';
import Button from 'react-bootstrap-button-loader';
import styles from '../../../styles/profile.module.css';
import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';
import TabProfile from './TabProfile';

import { withNamespaces } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    firstCell: {
        width: '350px',
        '@media (max-width: 600px)': {
            width: "160px"
        },
        textAlign: 'left',
        float: 'left'
    },
    secondCell: {
        width: '350px',
        '@media (max-width: 600px)': {
            width: "65px"
        },
        float: 'left'
    },
    rootProfile: {
        overflow: 'auto'
    }
}));

function EditProfile(props) {
    const classes = useStyles();

    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        resize();
    }, []);

    const resize = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const offSet = 50;

            const customHeight = height - titleBar - offSet;

            const element = document.querySelector('#divProfile');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 0);
    }

    const handleReload = () => {
        props.handleReload();
    }

    return (
        <LoadingOverlay
            active={isActive}
            spinner={<BeatLoader />}
            text={i18next.t('common:loading')}
        >
            <div>
                <TabProfile isPending={props.isPending} data={props.data} dataEmployee={props.dataEmployee} handleReload={handleReload} />
            </div>
        </LoadingOverlay>
    );
}

export default withNamespaces(['common', 'profile', 'buttons'], { wait: true })(EditProfile);